module.exports = __webpack_public_path__ + "static/media/bell-beaker_LBA_scotland_preview.5de535c4.png";